/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./error-404.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./error-404.component";
var styles_Error404Component = [i0.styles];
var RenderType_Error404Component = i1.ɵcrt({ encapsulation: 0, styles: styles_Error404Component, data: {} });
export { RenderType_Error404Component as RenderType_Error404Component };
export function View_Error404Component_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "h1", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["Hiba"])), (_l()(), i1.ɵted(-1, null, ["\n\n"])), (_l()(), i1.ɵeld(3, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["A keresett oldal nem tal\u00E1lhat\u00F3."])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, null); }
export function View_Error404Component_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "kkk-error-404", [], null, null, null, View_Error404Component_0, RenderType_Error404Component)), i1.ɵdid(1, 49152, null, 0, i2.Error404Component, [], null, null)], null, null); }
var Error404ComponentNgFactory = i1.ɵccf("kkk-error-404", i2.Error404Component, View_Error404Component_Host_0, {}, {}, []);
export { Error404ComponentNgFactory as Error404ComponentNgFactory };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/error-404/error-404.component.ngfactory.js.pre-build-optimizer.js